import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_USER_HISTORY = "[USER_HISTORY] GET_USER_HISTORY";
export const GET_USER_HISTORY_SUCCESS =
	"[USER_HISTORY] GET_USER_HISTORY_SUCCESS";
export const GET_USER_HISTORY_FAILED = "[USER_HISTORY] GET_USER_HISTORY_FAILED";

export const SET_VALUE = "[USER_HISTORY] SET_VALUE";
export const CLEAR_VALUES = "[USER_HISTORY] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getUserHistory(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_USER_HISTORY });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/userHistory?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_USER_HISTORY_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_USER_HISTORY_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_USER_HISTORY_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
